import { AuthReducer } from './auth/AuthSlice';
import { DescriptionsReducer } from './descriptions/DescriptionsSlice';

const reducer = {
    auth: AuthReducer,
    descriptions: DescriptionsReducer,
};

export default reducer;
